import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { ApiError } from '../lib/api';
import { BrandMark, Icon } from '../components/icons';

/** Claims the panel makes about the system, not about the account being used. */
const POINTS = [
  'Stok darah dihitung dari kantong individual, bukan penghitung terpisah.',
  'Setiap pesanan membawa jejak audit dari pengajuan sampai penerimaan.',
  'Tarif BPPD dan tagihan mengikuti kategori pasien secara otomatis.',
];

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      // Server messages are already written for humans — show them as-is.
      setError(err instanceof ApiError ? err.message : 'Tidak bisa menghubungi server.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <aside className="login-aside">
        <div className="row" style={{ gap: '0.7rem' }}>
          <BrandMark size={40} />
          <span className="label" style={{ color: 'var(--accent-secondary)' }}>
            Palang Merah Indonesia
          </span>
        </div>
        <div>
          <h1>Monitoring Darah</h1>
          <p className="lede" style={{ marginTop: '0.6rem' }}>
            Satu tempat untuk stok, pesanan, dan penagihan darah antar UDD dan rumah sakit.
          </p>
        </div>
        <ul className="login-points">
          {POINTS.map((p) => (
            <li key={p}>
              <Icon name="check" size={17} />
              <span>{p}</span>
            </li>
          ))}
        </ul>
      </aside>

      <div className="login-panel">
        <form onSubmit={submit} className="card stack login-form">
          <div className="page-head">
            <h2>Masuk</h2>
            <p>Gunakan akun yang diterbitkan PMI atau AiYO.</p>
          </div>

          {error && <div className="msg error">{error}</div>}

          <div className="field">
            <label className="label" htmlFor="email">Email</label>
            <input
              id="email" type="email" value={email} required autoComplete="username"
              placeholder="nama@pmi.or.id"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="label" htmlFor="password">Password</label>
            <input
              id="password" type="password" value={password} required autoComplete="current-password"
              placeholder="••••••••"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="primary" disabled={busy} style={{ padding: '0.7rem 1.15rem' }}>
            {busy ? 'Memeriksa…' : 'Masuk'}
          </button>
        </form>
      </div>
    </div>
  );
}
